import packageJson from '../package.json';

export const BACKEND_BASE_URL = window.environment.backendV1Url;
export const BACKEND_V2_BASE_URL = window.environment.backendV2Url;
export const DATA_STREAMER_BASE_URL = window.environment.datastreamerUrl;
export const ERROR_REPORTING_DSN = window.environment.errorReportingDns;
export const ENVIRONMENT = window.environment.env;
export const MAPS_SERVER_BASE_URL = window.environment.mapsNdwUrl;
export const VERSION = packageJson.version;
export const IS_DEV = window.environment.env === 'DEV';
export const IS_ACCEPTANCE = window.environment.env === 'ACC';
export const IS_PRODUCTION = window.environment.env === 'PROD';
export const RELOADING_INTERVALS = [5000, 10000, 15000, 20000, 30000, 60000];
export const ANALYTICS_ENABLED = window.environment.analyticsEnabled || false;
